import { useMemo } from 'react';

import { useGetSystemSettingsQuery } from '../modules/configurations/systemSettings/systemSettingsApi';

const DEFAULT_LOGO_SRC = '/assets/images/fadeout-logo.png';
const DEFAULT_FAVICON_SRC = '/assets/images/favicon.ico';

const normalizeUrl = (value?: string | null): string | null => {
  const trimmed = value?.trim();
  return trimmed ? trimmed : null;
};

export const useSystemBranding = () => {
  const { data, isFetching } = useGetSystemSettingsQuery();
  const settings = data?.data;

  return useMemo(
    () => ({
      logoUrl: normalizeUrl(settings?.logoUrl),
      faviconUrl: normalizeUrl(settings?.faviconUrl),
      companyName: normalizeUrl(settings?.companyName),
      copyrightText: normalizeUrl(settings?.copyrightText),
      updatedAt: normalizeUrl(settings?.updatedAt),
      logoSrc: normalizeUrl(settings?.logoUrl) ?? DEFAULT_LOGO_SRC,
      faviconSrc: normalizeUrl(settings?.faviconUrl) ?? DEFAULT_FAVICON_SRC,
      isFetching,
    }),
    [isFetching, settings]
  );
};

export default useSystemBranding;
